import Masajes from '../Image/Corpo/masajes.png'
import Electrodos from '../Image/Corpo/electrodos.png'
import Ultracavitador from '../Image/Corpo/ultracavitador.png'
import Criolipolisis from '../Image/Corpo/crio.png'


const DataCorpo = [
    {
        img: Masajes,
        title: "Masajes Reductores",
        description: "Reduce la acumulación de grasa en zonas específicas de nuestro cuerpo, como glúteos, abdomen, caderas, cintura o piernas. El proceso de reducción se produce porque se liberan ácidos grasos y toxinas acumuladas en la zona tratada, facilitando así su eliminación.",
        duracion: "30 min"
    },
    {
        img: Electrodos,
        title: "Electrodos",
        description: "La electroestimulación es una técnica que se utiliza en diversos ámbitos como el fitness o la fisioterapia. Se aplica a través de un dispositivo que se llama electroestimulador y unos electrodos que se adhieren al cuerpo y que emiten unos impulsos eléctricos para trabajar diferentes partes del organismo",
        duracion: "60 min"

    },
    {
        img: Criolipolisis,
        title: "Criolipolisis",
        description: "Es una técnica que elimina las células adiposas mediante un proceso de enfriamiento con una aplicación superficial.",
        duracion: "40 min"

    },
    {
        img: Ultracavitador,
        title: "Ultracavitador",
        description: "consiste en un tratamiento de tipo reductor indoloro de efectos inmediatos cuyo objetivo es eliminar los depósitos de grasa presentes en el cuerpo sin la necesidad de llevar a cabo un procedimiento quirúrgico.",
        duracion: "40 min"
    }
]

export default DataCorpo;